import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, UnaryFunction } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../../../service/modules/modules.component';
import { ServerService } from '../../../../service/server/server.service';
import { BankAccountsComponent } from '../../bank/bank-accounts/accounts-list/bank-accounts.component';


@Component({
  selector: 'app-cheque-detaile',
  templateUrl: './cheque-detaile.component.html',
  styleUrls: ['./cheque-detaile.component.scss']
})
export class ChequeDetaileComponent implements OnInit, OnDestroy {
  public isOnline: any;
  public loading = false;
  public subscription: Subscription | undefined;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any;
  lang: any;
  type_task: number | undefined;
  form1_group: FormGroup | any;
  user_info: any;
  user_id: number | any;
  id: number | undefined;
  i: number | undefined;
  code: number | undefined;
  title: string | undefined;
  search_array: any = [];
  document_type: number | undefined;
  number_temp: number | undefined;
  status_id_temp: number | undefined;
  result: any;
  ref: string = 'cheque';
  user: number = 0;
  trash: number = 2;
  list_not: any; // این از پاپ آپ تمور مالی و .. می آید . برای این که دو شماره چک تکرار نشود
  token: any;//این برای ذخیره موقت تعریف چک های دریافتی در سرویس  امور مالی می باشد و بعد از ذخیره نهایی بفهمد چه آیتم های را باید تراش برابر 2 کند.
  user_temp: string | undefined;// این برای گرفتن نام طرف حساب فعلی می باشد و غیر قابل تغییر می باشد.
  change_user: boolean = false; //اگر برابر با ترو باشد موقع ذخیره بررسی می کند که آیا این رکورد قبلا سند داشته است یا نه
  count_financial2: number = 0; // اگر بزرگتر از 0 باشد بعنی سند دارد و نباید نام ظرف حساب تغییر کند

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any, private dialog: MatDialog
    , private matDialogRef: MatDialogRef<ChequeDetaileComponent>) {
    this.server = this.serverService.get_server();
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.list_not = dialog_data.list_not;
      this.create_form1();
      this.id = dialog_data.id;
      this.ref = dialog_data.ref;
      if (this.ref == 'financial') {
        this.trash = 3; //وقتی از طریق امور مالی ذخیره می شود مقدار پیش فرض 3 می گیرد 
        this.token = dialog_data.token;
      }
      this.document_type = dialog_data.type;
      this.code = dialog_data.code;
      this.user = dialog_data.user;
      this.i = dialog_data.i;
      if (this.type_task == 1) {
        this.get_title();
        this.get_status();
        if (this.document_type == 2) this.get_bank_default();
        if (this.user) {
          this.get_user();
        }
      }
      if (this.type_task == 2 || this.type_task == 4) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        this.form1_group.patchValue({
          title: dialog_data.search_array.title,
          issue_date: dialog_data.search_array.issue_date,
          user_title: dialog_data.search_array.user_title,
          user: dialog_data.search_array.user,
          bank_title: dialog_data.search_array.bank_title,
          bank: dialog_data.search_array.bank,
          branch_name: dialog_data.search_array.branch_name,
          branch_code: dialog_data.search_array.branch_code,
          number: dialog_data.search_array.number,
          cheque_numbers_title: dialog_data.search_array.cheque_numbers_title,
          account_title: dialog_data.search_array.account_title,
          account: dialog_data.search_array.account,
          due: dialog_data.search_array.due,
          price: dialog_data.search_array.price,
          status_title: dialog_data.search_array.status_title,
          status_id: dialog_data.search_array.status_id,
        })
      }
    }
  }//end consructor

  ngOnInit() {
    this.server = this.serverService.get_server();
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }

  create_form1() {
    this.form1_group = new FormGroup({
      'number': new FormControl(null),
      'cheque_numbers_title': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'title': new FormControl(null),
      'branch_name': new FormControl(null),
      'branch_code': new FormControl(null),
      'issue_date': new FormControl(new Date()),
      'due': new FormControl(null),
      'sort': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'status_title': new FormControl(null),
      'status_id': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'bank_title': new FormControl(null),
      'bank': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'account_title': new FormControl(null),
      'account': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'user_title': new FormControl(null),
      'user': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'price': new FormControl(null, [Validators.pattern('[0-9]{1,}')])
    });
    if (this.type_task == 2 || this.type_task == 1) {
      this.form1_group.controls['issue_date'].setValidators([Validators.required])
      this.form1_group.controls['due'].setValidators([Validators.required])
      this.form1_group.controls['bank'].setValidators([Validators.required])
      this.form1_group.controls['account'].setValidators([Validators.required])
      this.form1_group.controls['user'].setValidators([Validators.required])
      this.form1_group.controls['status_id'].setValidators([Validators.required])
      this.form1_group.controls['price'].setValidators([Validators.required])
    }
  }

  check_access(type_task: any, excel: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2 || this.type_task == 4)) {
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.code }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.title = res['result'][0].title;
            this.loading = false;
            if (type_task == 1) { this.insert(); }
            if (type_task == 2) {
              if (this.change_user == true) {
                this.check_financial2();
              } else {
                this.update();
              }
            }
            if (type_task == 3) { this.search(excel); }
            if (type_task == 4) { this.get_data(); }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_title(): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.code }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.title = res['result'][0].title;
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_user() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1953, user: this.user }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            if (res['num'] == 1) {
              this.form1_group.patchValue({
                'user': res['result'][0].user_id,
                'user_title': res['result'][0].user_title
              })
            }
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  search(excel: number) {
    this.matDialogRef.close({
      title: this.form1_group.value.title,
      issue_date: this.form1_group.value.issue_date,
      user_title: this.form1_group.value.user_title,
      user: this.form1_group.value.user,
      bank_title: this.form1_group.value.bank_title,
      bank: this.form1_group.value.bank,
      branch_name: this.form1_group.value.branch_name,
      branch_code: this.form1_group.value.branch_code,
      number: this.form1_group.value.number,
      cheque_numbers_title: this.form1_group.value.cheque_numbers_title,
      account_title: this.form1_group.value.account_title,
      account: this.form1_group.value.account,
      due: this.form1_group.value.due,
      price: this.form1_group.value.price,
      status_title: this.form1_group.value.status_title,
      status_id: this.form1_group.value.status_id,
      export_excel: excel
    })
  }

  get_data() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1895, id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'branch_name': res['result'][0].branch_name,
            'branch_code': res['result'][0].branch_code,
            'issue_date': res['result'][0].issue_date,
            'number': res['result'][0].cheque_numbers,
            'cheque_numbers_title': res['result'][0].site_cheque_number,
            'user_title': res['result'][0].user_title,
            'user': res['result'][0].site_cheque_user,
            'title': res['result'][0].site_cheque_title,
            'due': res['result'][0].due_date,
            'sort': res['result'][0].site_cheque_sort,
            'status_id': res['result'][0].site_cheque_status,
            'status_title': res['result'][0].site_cheque_status_title,
            'bank_title': res['result'][0].site_bank_title,
            'bank': res['result'][0].site_cheque_bank,
            'account_title': res['result'][0].site_bank_accounts_number,
            'account': res['result'][0].site_cheque_account,
            'price': res['result'][0].site_cheque_price,
          }
          );
          this.user_temp = res['result'][0].site_cheque_user;
          this.count_financial2 = res['result'][0].count_financial2;
          this.document_type = res['result'][0].site_cheque_type;
          this.number_temp = res['result'][0].cheque_numbers;
          this.status_id_temp = res['result'][0].site_cheque_status;
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 1891, "user_id": this.user_id, type: this.document_type
      , 'status_id': this.form1_group.value.status_id
      , 'number': this.form1_group.value.number
      , 'branch_name': this.form1_group.value.branch_name
      , 'branch_code': this.form1_group.value.branch_code
      , 'issue_date': this.form1_group.value.issue_date
      , 'title': this.form1_group.value.title
      , 'due': this.form1_group.value.due
      , 'sort': this.form1_group.value.sort
      , 'bank': this.form1_group.value.bank
      , 'account': this.form1_group.value.account
      , 'user': this.form1_group.value.user
      , 'price': this.form1_group.value.price
      , 'trash': this.trash
      , 'token': this.token
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0] }
          )
          if (this.ref == 'cheque') {
            var pe_message = "با موفقیت ذخیره شد";
            var pe_action = "بستن";
            this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
          }
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "شماره چک درهر فاکتور مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert


  check_financial2(): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1954, id: this.id }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            var pe_message = "این رکورد سند امور مالی دارد قادر به تغییر نام طرف حساب نیستید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
            return false;
          } else {
            this.update();
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  update() {
    var obj = {
      'address': 1892, "user_id": this.user_id
      , 'number': this.form1_group.value.number
      , 'title': this.form1_group.value.title
      , 'branch_name': this.form1_group.value.branch_name
      , 'branch_code': this.form1_group.value.branch_code
      , 'issue_date': this.form1_group.value.issue_date
      , 'due': this.form1_group.value.due
      , 'sort': this.form1_group.value.sort
      , 'status_id': this.form1_group.value.status_id
      , 'bank': this.form1_group.value.bank
      , 'account': this.form1_group.value.account
      , 'user': this.form1_group.value.user
      , 'price': this.form1_group.value.price
      , 'id': this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0] }
          )
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);

        }//end if
        else if (res['status'] == 4) {
          var pe_message = "شماره چک درهر حساب مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end update

  get_bank_default() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1965 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            account_title: res['result'][0].site_bank_accounts_number,
            account: res['result'][0].site_bank_accounts_id,
            branch_name: res['result'][0].site_bank_accounts_branch_title,
            bank_title: res['result'][0].site_bank_title,
            bank: res['result'][0].site_bank_accounts_bank,
            branch_code: res['result'][0].site_bank_accounts_branch_code,
          });
          this.get_number_cheque();
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_status() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1905 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            status_id: res['result'][0].site_cheque_status_id,
            status_title: res['result'][0].site_cheque_status_title,
          })
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  select_account(): any {
    if (!this.form1_group.value.bank) {
      var pe_message = "لطفا در ابتدا بانک خود را انتخاب نمائید";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return false;
    }
    const dialog_data = this.dialog.open(BankAccountsComponent, {
      width: '55rem',
      height: 'auto',
      data: { ref: 'cheque', id: this.form1_group.value.bank }
    });
    dialog_data.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.form1_group.patchValue({
            'account_title': res.number,
            'account': res.id,
            'branch_name': res.branch_title,
            'branch_code': res.branch_code
          });
          this.get_number_cheque();
        }
      }
    )
  }

  get_number_cheque() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var obj = {
      address: 1951,
      account_number: this.form1_group.value.account,
      token: this.token,
      list_not: this.list_not
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.form1_group.patchValue({
              'number': res['result'][0].cheque_numbers_id,
              'cheque_numbers_title': res['result'][0].cheque_numbers_title,
            });
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت اولین شماره چک خالی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  reset_account() {
    this.form1_group.patchValue({
      'account_title': null,
      'account': null
    })
  }


  load_services(id: number): any {
    if (this.type_task == 4) {
      return false;
    }
    if ((id == 161 && this.user > 0) || (id == 161 && this.count_financial2 > 0)) {
      var pe_message = "این رکورد سند امور مالی دارد قادر به تغییر نام طرف حساب نیستید";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return false;
    }

    var where = "";
    var code_id: number | undefined;
    var record_id: number | undefined;
    if (id == 190) {
      code_id = 1949;
      var record_id = this.id;
    }
    if (id == 194) {
      if (!this.form1_group.value.account) {
        var pe_message = "لطفا در ابتدا شماره حساب را تعیین کنید";
        var pe_action = "بستن";
        this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        return false;
      }
      code_id = 1950;
    }
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, where: where, code_id: code_id, record_id: record_id, obj: { account_number: this.form1_group.value.account, list_not: this.list_not } }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 190) {
            this.form1_group.patchValue({
              'status_id': res.id,
              'status_title': res.title
            })
          }
          if (id == 178) {
            this.form1_group.patchValue({
              'bank': res.id,
              'bank_title': res.title,
              'number': null,
              'cheque_numbers_title': null,
              'account_title': null,
              'account': null,
              'branch_name': null,
              'branch_code': null,
              'price': null
            })
          }
          if (id == 161) {
            this.form1_group.patchValue({
              'user': res.id,
              'user_title': res.title
            });
            if (this.user_temp != this.form1_group.user) {
              this.change_user = true;
            }
          }
          if (id == 194) {
            this.form1_group.patchValue({
              'number': res.id,
              'cheque_numbers_title': res.title
            })
          }
        }
      }
    )

  }


  reset_input(id: number): any {
    if (this.type_task == 4) {
      return false;
    }
    if ((id == 161 && this.user > 0) || (id == 161 && this.count_financial2 > 0)) {
      var pe_message = "این رکورد سند امور مالی دارد قادر به تغییر نام طرف حساب نیستید";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return false;
    }
    if (id == 190) {
      this.form1_group.patchValue({
        'status_title': null,
        'status_id': null
      })
    }
    if (id == 178) {
      this.form1_group.patchValue({
        'bank_title': null,
        'bank': null,
        'number': null,
        'cheque_numbers_title': null,
        'account_title': null,
        'account': null,
        'branch_name': null,
        'branch_code': null,
        'price': null
      })
    }
    if (id == 161) {
      this.form1_group.patchValue({
        'user': null,
        'user_title': null
      })
    }
    if (id == 194) {
      this.form1_group.patchValue({
        'number': null,
        'cheque_numbers_title': null
      })
    }
  }


  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }

  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 8000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 8000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
